import classnames from 'classnames';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import SkeletonBlock from 'dpl/common/design_system/SkeletonBlock';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import UserAvatar, {
  AVATAR_SIZES
} from 'dpl/path_to_payment/components/UserAvatar';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';
import useToggle from 'dpl/shared/hooks/useToggle';

import NavMenuDrawer from '../components/NavMenuDrawer';
import useInitialHeaderState from '../hooks/useInitialHeaderState';

const AVATAR_SIZE = 'xxm';
const AVATAR_PIXEL_SIZE = `${AVATAR_SIZES[AVATAR_SIZE].diameter}px`;

export default function MobileNavContainer() {
  const [isMenuOpen, toggleIsMenuOpen] = useToggle(false);
  const { hasUnifiedMobileNav } = useInitialHeaderState();
  const { isFetching: isFetchingUser, user, isLoggedIn } = useCurrentUser();

  const { isFetching: isFetchingNotifications, hasNotifications } =
    useNotificationCounts();

  const menuIconName = hasUnifiedMobileNav ? 'fetch-search-menu' : 'fetch-menu';
  const isLoading = isFetchingUser || isFetchingNotifications;

  return (
    <>
      <div className="MobileNavContainer flex items-center">
        {!isLoading && (
          <button
            type="button"
            className={classnames(
              'relative flex items-center justify-center secondary'
            )}
            onClick={toggleIsMenuOpen}
            style={
              !isLoggedIn
                ? { height: AVATAR_PIXEL_SIZE, width: AVATAR_PIXEL_SIZE }
                : null
            }
          >
            {isLoggedIn ? (
              <UserAvatar
                user={{ ...user, id: user.user_id }}
                size={AVATAR_SIZE}
              />
            ) : (
              <Icon name={menuIconName} height="24px" width="24px" />
            )}
            {hasNotifications && (
              <span
                className="absolute db bg-stone-700 ba bw1 b--white br-100 pv1 ph1"
                style={{ top: '-2px', right: '-2px' }}
              />
            )}
          </button>
        )}
        {isLoading && (
          <SkeletonBlock
            className="flex-shrink-0 ba b--default br-100"
            height={AVATAR_PIXEL_SIZE}
            width={AVATAR_PIXEL_SIZE}
          />
        )}
      </div>
      {isMenuOpen && <NavMenuDrawer onClose={toggleIsMenuOpen} />}
    </>
  );
}
